const state = {
  verificationDetail: {
    phoneNumber: null,
    countryCode: null,
    formatedPhoneNumber: null,
    lineType: null,
    verified: false,
  },
}

const getters = {
  verificationDetail: (state) => state.verificationDetail,
}

const mutations = {
  setVerificationDetail(state, data) {
    state.verificationDetail = data;
  },
}

export default {
  state,
  getters,
  mutations,
}
